import {mergeToHierarchy} from '#core/utils/config-utils.js';

import {AbstractVisualFeature} from '#core/application/modules/visual-feature.js';

import {SportsContent} from '../sports-content.js';

import {eventPageFactory} from './event-page.factory';

import PALETTE_SCHEMA from './event-page.palette-schema.yaml';
import SCHEMA from './event-page.schema.yaml';

class EventPageFeature extends AbstractVisualFeature {
    get name() {
        return 'EventPage';
    }

    get configSchema() {
        return SCHEMA;
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getVisualConfig(PALETTE) {
        return eventPageFactory(PALETTE);
    }

    beforeMojitoConfigBuild(mojitoConfig) {
        const {prebuiltBetsPosition, priceBoostedMarketsPosition} = this.config;

        mergeToHierarchy(mojitoConfig, 'services.configurations', {
            EventMarkets: {
                prebuiltBetsPosition,
                priceBoostedMarketsPosition,
            },
        });

        super.beforeMojitoConfigBuild(mojitoConfig);
    }
}

export const EventPage = new EventPageFeature(SportsContent);
